exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/modules/_wks-ext.js
// module id = 47
// module chunks = 48